module.exports = __webpack_public_path__ + "img/logoseebvarginha.bd25ade0.png";